// extracted by mini-css-extract-plugin
export default {"dockShell":"Dock_dockShell__KYWVH","dockPill":"Dock_dockPill__P6gxO","appSlot":"Dock_appSlot__wLe-7","icon":"Dock_icon__W9CKj","separator":"Dock_separator__FjnG4"};